export default "__VITE_ASSET__410b0e9e__"